(function ($) {
  var namespace = 'tewrap'
  var device = navigator.userAgent
  var phone = (device.indexOf('iPhone') > 0 && device.indexOf('iPad') === -1) || device.indexOf('Android') > 0
  var methods = {
    init: function (options) {
      options = $.extend({
        phoneNumber: '00-00-00000'
      }, options)

      if (!phone) {
        return methods.destroy.call(this)
      }

      return this.each(function () {
        var $this = $(this)
        var data = $this.data(namespace)
        if (!data) {
          options = $.extend({
            phoneNumber: $this.data('tewrap-number')
          }, options)
          $this.data(namespace, {
            options: options
          })

          // if (phone) {
          $this.wrap('<a href="tel:' + options.phoneNumber + '"></a>')
          // }
        }
      }) // end each
    },
    destroy: function () {
      return this.each(function () {
        var $this = $(this)
        $(window).unbind('.' + namespace)
        $this.removeData(namespace)
      })
    }
  }
  $.fn.tewrap = function (method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1))
    } else if (typeof method === 'object' || !method) {
      return methods.init.apply(this, arguments)
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.' + namespace)
    }
  }
})($)



// WEBPACK FOOTER //
// ./src/js/lib/tewrap.js